<template>
  <nav aria-label="Paginación de productos">
    <ul class="pagination justify-content-center gap-1">

      <!-- Prev -->
      <li class="page-item" :class="{ disabled: current <= 1 }">
        <a class="page-link q-page-link" @click="previousPage" href="#">
          <i class="bi bi-chevron-left"></i>
        </a>
      </li>

      <!-- Ellipsis left -->
      <li class="page-item disabled" v-if="current - pageInterval / 2 > 0">
        <span class="page-link q-page-link q-page-ellipsis">···</span>
      </li>

      <!-- Pages -->
      <template v-for="n in totalPages">
        <li
          v-if="inIntervalPage(n)"
          :key="n"
          class="page-item"
          :class="{ active: isActive(n) }"
        >
          <a class="page-link q-page-link" @click="setPage(n)" href="#">{{ n }}</a>
        </li>
      </template>

      <!-- Ellipsis right + last page -->
      <template v-if="totalPages > pageInterval">
        <li class="page-item disabled" v-if="totalPages > current + pageInterval / 2">
          <span class="page-link q-page-link q-page-ellipsis">···</span>
        </li>
        <li class="page-item" v-if="totalPages >= current + pageInterval / 2">
          <a class="page-link q-page-link" @click="setPage(totalPages)" href="#">{{ totalPages }}</a>
        </li>
      </template>

      <!-- Next -->
      <li class="page-item" :class="{ disabled: current >= totalPages }">
        <a class="page-link q-page-link" @click="nextPage" href="#">
          <i class="bi bi-chevron-right"></i>
        </a>
      </li>

    </ul>
  </nav>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "GridPagination",
  data() {
    return {
      current: 1,
      pageInterval: window.matchMedia("(max-width: 575.98px)").matches ? 5 : 11,
    };
  },
  computed: {
    ...mapGetters({ totalPages: "ecommerce/totalPages" }),
  },
  methods: {
    ...mapActions({ loadProducts: "ecommerce/loadProducts" }),
    ...mapMutations({ setPageNumber: "ecommerce/SET_PAGE_NUMBER" }),
    setPage(num) {
      this.current = num;
      this.setPageNumber(num);
      this.loadProducts();
    },
    isActive(i) { return i === this.current; },
    previousPage() {
      if (this.current > 1) { this.current--; this.setPageNumber(this.current); this.loadProducts(); }
    },
    nextPage() {
      if (this.current < this.totalPages) { this.current++; this.setPageNumber(this.current); this.loadProducts(); }
    },
    inIntervalPage(index) {
      if (this.totalPages <= this.pageInterval) return true;
      const half = this.pageInterval / 2;
      let lo = this.current - half;
      let hi = this.current + half;
      if (lo < 0) { lo = 0; hi = this.pageInterval; }
      return index > lo && index < hi;
    },
  },
};
</script>

<style scoped>
.pagination {
  flex-wrap: wrap;
}
.q-page-link {
  font-family: var(--q-font-mono);
  font-size: 12px;
  min-width: 34px;
  text-align: center;
  border-radius: var(--q-radius) !important;
  transition: all var(--q-transition);
}
.q-page-ellipsis { letter-spacing: 0.1em; }
.page-item.active .q-page-link {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: #ffffff;
  font-weight: 700;
}
@media (max-width: 575.98px) {
  .q-page-link {
    min-width: 28px;
    padding: 4px 5px;
  }
}
</style>
